<lib-tiptap-editor-dual-lang
  [inputFormControlName]="inputFormControlName()"
  [id]="id()"
  [name]="name()"
  [label]="label()"
  [placeholderEn]="placeholderEn()"
  [placeholderAr]="placeholderAr()"
  [inputClass]="inputClass()"
  [width]="width()"
  [height]="height()"
  [isHasToolTip]="isHasToolTip()"
  [canResize]="canResize()"
  [startIcon]="startIcon()"
  [endIcon]="endIcon()"
  [minlength]="minlength()"
  [maxlength]="maxlength()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  [value]="value()"
  [requiredEn]="requiredEn()"
  [requiredAr]="requiredAr()"
  [requiredGroup]="requiredGroup()"
  [isSingleInput]="isSingleInput()"
  [equation]="equation()"
  (endIconCLick)="endIconCLick.emit()"
  (typing)="typing.emit($event)" />
